export default __webpack_public_path__ + "static/media/table.36ded99a.svg";